__turbopack_context__.v({
  "icon": "IAMP1W_icon",
});
